/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';

import WidgetDialog from '../components/dialogs';
import ContentContainer from '../components/contentContainer';
import CopyLinkButton from '../components/copyLinkButton';
import TitleHeader from '../components/titleHeader';
import GuideLink from '../components/guidelink';
import WaitSpinner from '../components/waitspinner';

import { useStyles } from './styles';
import useICSLink from './useICSLink';

import useWidgetTheme from '../../commons/widgetTheme';
import TranslationIds from '../../commons/translationIds';
import useTranslator from '../../commons/translations';
import getCommonUIStyles from '../../commons/uiStyles';

import usePageTransitions from '../../store/models/animations/usePageTransitions';
import {
    TransitionViewNames,
} from '../../store/models/animations/actions/transitions';

import useKickstarted from '../../commons/hooks/useKickstarted';

function ICSLink (props) {
    const {
        viewAnimation = false,
        initStyles = {},
    } = props;

    const  {
        translate,
    } = useTranslator();

    const {
        widget,
        widgetTheme,
        appStore,
    }  = useWidgetTheme();

    const {
        calendarURL,
        copyCalendarURL,
        subuscriberStatus,
        inProgress,
        selectedCalendar,
    } = useICSLink();

    const classes = useStyles({
        inProgress,
        widget,
        widgetTheme,
        commonUIStyles: getCommonUIStyles({ widgetTheme, widget }),
    });

    usePageTransitions({
        elementName: TransitionViewNames.ICSLINK_VIEW,
        viewAnimation,
    });

    useKickstarted({});

    if (!appStore.kickstarted) {
        return (<React.Fragment></React.Fragment>);
    }

    return (
        <React.Fragment>
            <ContentContainer
                viewAnimation={viewAnimation}
            >
                <WidgetDialog
                    isShowBackButton={false}
                    name={TransitionViewNames.ICSLINK_VIEW}
                    viewAnimation={viewAnimation}
                    initStyles={initStyles}
                    >
                    <TitleHeader
                        widget={widget}
                        widgetTheme={widgetTheme}
                        title={`${translate(TranslationIds.CALENDAR_PROC_TITLE)}`}
                        subtitle={''}
                    />
                    <Grid className={classNames([classes.body])}>
                        <Grid className={classNames([classes.bodyMessages])}>
                            {translate(TranslationIds.OTHER_CALENDAR_INSTRUCTIONS)}
                        </Grid>

                        <Grid className={classNames([classes.bodyMessages])}>
                            <span className={classes.copythislink}>
                                {translate(TranslationIds.COPY_THIS_LINK)}
                            </span>
                        </Grid>

                        <Grid className={classNames([classes.linkSpace])}>
                            <span className={classNames(['data-ecal-webcall-link', classes.link])}>
                                { calendarURL }
                            </span>

                            <CopyLinkButton
                                inProgress={inProgress}
                                buttonClass={inProgress ?
                                    classNames([
                                        classes.copyButtonBase,
                                        classes.copyButtonSolid]) :
                                    classNames([
                                        classes.copyButtonBase,
                                        classes.copyButtonOutlined])
                                }

                                onClick={() => {
                                    copyCalendarURL();
                                    subuscriberStatus();
                                }}
                                copyLabel={translate(TranslationIds.CALENDAR_GUIDE_COPY)}
                                copiedLabel={translate(TranslationIds.CALENDAR_GUIDE_COPIED)}
                            />
                        </Grid>

                        <Grid>
                            <WaitSpinner
                                visible={inProgress}
                                commonUIStyles={getCommonUIStyles({ widgetTheme, widget })}
                                text={translate(TranslationIds.CALENDAR_PROC_SPINNER)}
                            />
                        </Grid>

                        <Grid className={classes.help}>
                            { translate(TranslationIds.CALENDAR_PROC_NEED_HELP) }
                            <GuideLink
                                selectedCalendar={selectedCalendar}
                                label={translate(TranslationIds.CALENDAR_PROC_GUIDE)}
                                commonUIStyles={getCommonUIStyles({ widgetTheme, widget })}
                            />
                        </Grid>
                    </Grid>
                </WidgetDialog>
            </ContentContainer>           
        </React.Fragment>
    );
}

ICSLink.propTypes = {
    viewAnimation: PropTypes.bool,
    initStyles: PropTypes.any,
};

export default observer(ICSLink);